import React, {useEffect, useState} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {Button} from "@material-ui/core";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";

import HistoryClinicIcon from "../../../assets/img/historial-prestaciones.svg";
import {ConsultationPatientGet} from "../../../services/consultationService";
import {PatientGet, PatientSearch} from "../../../services/patientService";
import {showToast, ToastType} from "../../../utils/ToastUtil";
import {useStateAuthValue} from "../../../context/Auth/AuthState";
import {useToast} from "../../../context/Toast/ToastProvider";
import PersonalData from "./personalData";
import ConsultationData from "./consultationData";
import LoadingSpinner from "../../../components/LoadingSpinner";

const HistoryClinicDialog = ({email}) => {
  const [userData] = useStateAuthValue();
  const history = useHistory();
  const toastDispatch = useToast();
  const [dataHC, setDataHC] = useState();
  const [dataPatient, setDataPatient] = useState();
  const [page, setPage] = useState(0);
  const [loadingHC, setLoadingHC] = useState(false);
  const [loadingPatient, setLoadingPatient] = useState(false);
  const [isNextPageDisabled, setIsNextPageDisabled] = useState(false);
   const [totalCount, setTotalCount] = useState(0);

  //TODO se realiza de esta manera porque desde el back no me devuelve limite, se pone 100000 por defecto
  const [limit, setLimit] = useState(100000);
  
  const errorMessagePatient = "Ocurrió un error en la búsqueda del paciente";
  const errorMessageConsultation = "Ocurrió un error en la búsqueda de la consulta";

  useEffect(() => {
    if (userData?.userToken) {
      setLoadingPatient(true);
      getDataPatient();
    }
  }, [email, userData?.userToken]);

  useEffect(() => {
    if (userData?.userToken && dataPatient?.id_number) {
      setLoadingHC(true);
      if (page < limit - 1) {
        setIsNextPageDisabled(false);
      }
      getDataHC();
    }
  }, [userData?.userToken, page, dataPatient?.id_number]);

  const getDataHC = async () => {
    const previusData = dataHC;
    const params = {
                    idNumber: dataPatient?.id_number,
                  };
      let emails = await getUserLogins(params);
    await ConsultationPatientGet(
      userData?.userToken,
      { patientLogin: encodeURIComponent(emails) , page: page, size:1,sort:'createdDate,desc' },
      (sessionError) => showError(sessionError)
    )
      .then((response) => {
        const count = response?.headers?.['x-total-count'] || 0;
        setTotalCount(count);
        if ((response?.data.length === 0 || response?.data === null || response?.data === '' ) && page !== 0) {
          setDataHC(previusData);
          setIsNextPageDisabled(true);
          setLimit(page);
          setPage(page - 1);
          
        } else {
          setDataHC(response?.data);
        }
      })
      .catch(() => {
        showError(errorMessageConsultation);
      })
      .finally(() => setLoadingHC(false));
  };

  const showError = (msgError) => {
    showToast(toastDispatch, msgError, ToastType.ERROR, ToastType.ERROR);
  };

    const getUserLogins = async (params) => {
      
          const res = await PatientSearch(userData.userToken, params)
            .then((response) => {
              const userLogins = response?.data.map(item => item.userLogin).join(",");
              return userLogins;
            })
          ;
          return res;
       };

  const getDataPatient = async () => {
    await PatientGet(email, userData.userToken, (sessionError) =>
      showError(sessionError)
    )
      .then((response) => {
        setDataPatient(response?.data);
      })
      .catch(() => {
        showError(errorMessagePatient);
      })
      .finally(() => setLoadingPatient(false));
  };


  const consultation = () => {
    return loadingHC ? (
      <LoadingSpinner />
    ) : (
      <div className="column">
        <ConsultationData data={dataHC} />
      </div>
    );
  };

  return (
    <div className="history-clinic-detail">
      <div className="header-hc">
        <img className="image" src={HistoryClinicIcon} alt="Historia Clinica" />
        <h2>
          Historia Clínica N° {dataPatient?.patient_dto?.clinicHistoryId} - {dataPatient?.last_name},{" "}
          {dataPatient?.first_name}
        </h2>
      </div>
      {loadingPatient ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="column">
            <PersonalData data={dataPatient} />
              {totalCount == 0 && !loadingHC && (
                  <div className={`btn-wrapper`} >No se encontraron consultas para este paciente</div>
                ) }
          </div>
           {totalCount > 0 && (
             <>
          <div className={`btn-wrapper`}>
          
            <span style={{fontWeight: 600}}>Consulta N°  {dataHC?.consultationId}</span>
            <span style={{backgroundColor: '#e0e7ff', color: '#3730a3', padding: '2px 10px', borderRadius: '12px', fontSize: '0.85rem', fontWeight: 500}}>
              {page + 1} de {totalCount}
            </span>
            <Button
                className={`btn btn--back ${isNextPageDisabled && "btn--disabled"}`}
                endIcon={<DoubleArrowIcon className="icon-back" size={24}/>}
                onClick={() => !isNextPageDisabled && setPage(page + 1)}
            >
              Consulta anterior
            </Button>
            <Button
                className={`btn btn--next ${page < 1 && "btn--disabled"}`}
                startIcon={<DoubleArrowIcon size={24}/>}
                onClick={() => page > 0 && setPage(page - 1)}
            >
              Consulta siguiente
            </Button>
          </div>
          {consultation()}
          </>
          )}
        </>
      )}
    </div>
  );
};

export default HistoryClinicDialog;

